import React, { Component } from "react";
import { TextField } from '@material-ui/core';
import axios from "axios";

class InputCep extends Component {

    maskCep = value => {
        if (!value) {
            return null;
        }
        return value
            .replace(/\D/g, '')
            .replace(/^(\d{5})(\d+)$/, '$1-$2')
    }
    
    handleCep = async e => {
        let value = this.maskCep(e.target.value);
        e.target.value = value;
        this.props.onChange(e);
        this.findAddress(value);
    }

    findAddress = (value) => {
        if (value && value.length === 9) {
            let cep = value.replace(/\D/g, '')
            if (cep.length === 8) {
                    if(this.props.onStartRequest) {
                        this.props.onStartRequest();
                    }
                    let promise = axios.get(`https://viacep.com.br/ws/${cep}/json`)
                    promise.then(resp => this.props.onFindAddress(resp.data))
                        .catch( err => {
                            // TODO
                        }).finally(() => {
                            if(this.props.onStopRequest) {
                                this.props.onStopRequest();
                            }
                        })

            }
        }
    }

    render() {
        return (
            <TextField
                variant={this.props.variant} 
                margin={this.props.margin} 
                fullWidth={this.props.fullWidth} 
                required={this.props.required} 
                label={this.props.label} 
                name={this.props.name}
                disabled={this.props.disabled}
                className={`MuiOutlinedInput-root ${this.props.className}`}
                autoComplete="documento"
                autoFocus
                onChange={this.handleCep}
                error={this.props.error}
                value={this.maskCep(this.props.value)}
                inputProps={{ maxLength: 9 }}
            />
        )
    }
}

export default InputCep;